(ns practitest.frontend.components.card-view
  (:require
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.components.confirmation :as confirmation]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.overflow :as overflow]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components.tooltip :as tooltip]
    [reagent.core :as reagent]))

(defn confirmation-dialog [show? details]
  [confirmation/confirm
   {:show? show?
    :title (:title @details)
    :body (:body @details)
    :yes-label (:yes-label @details)
    :on-yes (:on-yes @details)
    :no-label (:no-label @details)
    :on-no (:on-no @details)
    :test-id (:test-id @details)
    :dialog-test-id (:dialog-test-id @details)
    :entity-name (:entity-name @details)
    :destructive? (:destructive? @details)
    :close-on-escape? (:close-on-escape? @details)
    :require-typed-confirmation (:require-typed-confirmation @details)}])

(defn menu-item [{:keys [hide! show-confirmation! hide-confirmation!]}
                 {:keys [id label on-click icon confirmation href disabled? tooltip test-id class]}]
  (let [item [:a.menu-item-element
              (dom/add-test-id
                {:id id
                 :href href
                 :class (dom/classes-pairs-v :disabled disabled? class (some? class))
                 :on-click (fn [_]
                             (when (and (not disabled?) on-click)
                               (hide!)
                               (if confirmation
                                 (show-confirmation! (assoc confirmation
                                                       :on-yes (fn []
                                                                 (hide-confirmation!)
                                                                 (on-click))
                                                       :on-no hide-confirmation!))
                                 (on-click))))}
                test-id)
              (when icon
                [:span.icon-holder [icon]])
              [overflow/overflow-with-mux-tooltip {}
               (fn [props]
                 [:div.menu-item-text props label])]]]
    (if tooltip
      [tooltip/mux-tooltip {:position "top"} tooltip
       (fn [props]
         (update item 1 merge props))]
      item)))

;; TODO: move to generic helper ?
(defn dropdown-menu [{:keys [show? toggle! hide! id menu-items class disabled? tooltip container flip? test-id placement]}]
  (let [trigger [:div.mux-card-dropdown-trigger
                 (dom/add-test-id
                   {:id       id
                    :class    (dom/classes-pairs-v :disabled disabled?)
                    :on-click (when (not disabled?) toggle!)}
                   test-id)
                 [icons/mux-three-dots]]]
    [:div
     {:class class}
     [overlay2/floating-ui-overlay
      {:placement (or placement "left-start")
       :offset 5
       :flip flip?
       :container container
       :on-request-close hide!
       :show? @show?}

      (if (and disabled? tooltip)
        [tooltip/mux-tooltip {:position "top"} tooltip
         (fn [props]
           (update trigger 1 merge props))]
        trigger)

      (into [:div.menu-popup] menu-items)]]))

(defn card [observer component menu-items menu-btn-test-id _entity]
  (let [state (reagent/atom {:show-dropdown? false
                             :show-confirmation? false
                             :confirmation-details nil})
        show-dropdown? (reagent/cursor state [:show-dropdown?])
        hide-dropdown! #(swap! state assoc :show-dropdown? false)
        toggle-dropdown! #(swap! state update :show-dropdown? not)
        show-confirmation? (reagent/cursor state [:show-confirmation?])
        show-confirmation! (fn [details]
                             (swap! state assoc
                                    :confirmation-details details
                                    :show-confirmation? true))
        hide-confirmation! #(swap! state assoc :show-confirmation? false)]
    (fn [_observer _component _menu-items _menu-btn-test-id _entity]
      (let [card-ref (reagent/atom nil)]
        (reagent/create-class
         {:component-did-mount #(.observe observer @card-ref)
          :component-will-unmount #(.unobserve observer @card-ref)
          :reagent-render (fn [_ _ _ _ entity]
                            [:div {:ref #(reset! card-ref %) :id (:id entity)}
                             [component entity]
                             [dropdown-menu {:show? show-dropdown?
                                             :class "float-end"
                                             :toggle! toggle-dropdown!
                                             :hide! hide-dropdown!
                                             :id (str "card-" (:id entity))
                                             :test-id menu-btn-test-id
                                             :menu-items (for [item (menu-items entity)]
                                                           [menu-item
                                                            {:hide! hide-dropdown!
                                                             :show-confirmation! show-confirmation!
                                                             :hide-confirmation! hide-confirmation!}
                                                            item])}]
                             [confirmation-dialog
                              show-confirmation?
                              (reagent/cursor state [:confirmation-details])]])})))))

(defn view [{:keys [on-visibility-change]}]
  (let [observer (js/IntersectionObserver.
                  (fn [entries _]
                    (when on-visibility-change
                      (doseq [entry entries]
                        (let [visible? (.-isIntersecting entry)
                              card-id (.-id (.-target entry))]
                          ;; NOTE: should we only fire the callback if the card becomes visible?
                          ;;       maybe it will be useful to know when it's hidden too
                          (on-visibility-change card-id visible?))))))]
    (fn [{:keys [entities component menu-items on-scroll menu-btn-test-id]}]
      [:div.mux-card-view
       (cond-> {}
         on-scroll (assoc :on-scroll on-scroll))
       (for [entity @entities]
         ^{:key (str "card-" (:id entity))}
         [:div.mux-card
          [card observer component menu-items menu-btn-test-id entity]])])))
